//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import links from '~/config/footer'
export default {
    name: 'AppFooter',

    data: () => ({
        links
    }),

    methods: {
        getHref(link){
            if(link.href && link.href.name)
                return link.href.name

            if(link.href)
              return link.href

            return null
        }
    }

}
